import api from "../utils/api";
import { LOGOUT } from "./types";

export const save = (payload = {}) => async (dispatch) => {
  try {
    const res = await api.post("/accounts/business-expenses", payload);
    return res.data;
  } catch (err) {
    if (err?.response?.status === 401) dispatch({ type: LOGOUT });
    return {
      success: false,
      error: err?.response?.data?.error || { message: err?.message || "The business expense could not be saved." },
    };
  }
};
